import React from 'react';

const Emoji = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16ZM10.3148 20.1527C11.1833 20.9427 12.0721 21.517 12.9718 21.9006C14.5285 22.5643 16.0559 22.63 17.4557 22.3258C19.0723 21.9745 20.506 21.1355 21.6595 20.1748C22.3851 19.5705 21.9039 18.5 20.9596 18.5C20.6905 18.5 20.4321 18.599 20.2219 18.767C19.3016 19.5024 18.207 20.1159 17.031 20.3714C16.0001 20.5954 14.8988 20.548 13.7562 20.0608C13.1293 19.7936 12.4719 19.3861 11.7968 18.7949C11.586 18.6103 11.3184 18.5 11.0383 18.5C10.127 18.5 9.64069 19.5396 10.3148 20.1527ZM12.5052 15C13.6098 15 14.5052 14.1046 14.5052 13C14.5052 11.8954 13.6098 11 12.5052 11C11.4007 11 10.5052 11.8954 10.5052 13C10.5052 14.1046 11.4007 15 12.5052 15ZM19.5052 15C20.6098 15 21.5052 14.1046 21.5052 13C21.5052 11.8954 20.6098 11 19.5052 11C18.4007 11 17.5052 11.8954 17.5052 13C17.5052 14.1046 18.4007 15 19.5052 15Z" />
  </svg>
);

export default Emoji;
